document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.collection-tabs__list');
  if (!slider) return;

  let isDown = false;
  let isDragging = false;
  let startX;
  let scrollLeft;

  // --------------------
  // DRAG
  // --------------------

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    slider.classList.add('dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('dragging');
    setTimeout(() => isDragging = false, 50);
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;

    const x = e.pageX - slider.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > 5) {
      isDragging = true;
    }

    slider.scrollLeft = scrollLeft - walk;
  });

  // --------------------
  // CLICK + AUTO SCROLL
  // --------------------

  const links = slider.querySelectorAll('.collection-tabs__list-link');

  links.forEach(link => {
    link.addEventListener('click', function (e) {

      if (isDragging) {
        e.preventDefault();
        return;
      }

      this.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });

    });
  });

});